import createDeepEqualSelector from 'utils/reselect/typescript/createDeepEqualSelector';
import { selectWaterSource } from 'services/waterSource/selectors';

const selectOptions = createDeepEqualSelector(
    selectWaterSource,
    (waterSourceState) =>
        waterSourceState &&
        waterSourceState.map((item: any) => {
            const { id, name } = item;

            return {
                key: id,
                text: name,
                value: id
            };
        })
);

const makeSelectOptions = (): typeof selectOptions => selectOptions;

export { selectOptions, makeSelectOptions };
